var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogoKuvaBySensirionInvert = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 360 144",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #ff6a14;\n      }\n\n      .st1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.87,58.41l-7.54,8.44v16.49h-16.87V18.66h16.87v26.72l23.26-26.72h19.68l-24.8,27.87,27.35,36.81h-19.17l-18.79-24.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M168.36,18.66v64.68h-16.87v-8.18c-4.35,5.75-11.38,9.97-20.71,9.97-17,0-25.56-11.38-25.56-28.76V18.66h16.87v34.51c0,9.84,4.47,16.23,13.8,16.23s15.59-7.41,15.59-18.92v-31.83h16.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M250.49,18.66l-26.72,64.68h-19.05l-26.71-64.68h18.53l17.77,46.02,17.77-46.02h18.41Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M287.81,16.87c-18.85,0-34.13,15.28-34.13,34.13s15.28,34.13,34.13,34.13,34.13-15.28,34.13-34.13-15.28-34.13-34.13-34.13ZM287.81,69.15c-10.02,0-18.15-8.13-18.15-18.15s8.13-18.15,18.15-18.15,18.15,8.13,18.15,18.15-8.13,18.15-18.15,18.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M305.96,18.66h17v64.68h-17V18.66Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 261.67,
    cy: 51,
    r: 7.99
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.85,121.55c-2.35,0-4.21-1.16-5.24-3.25h-.13v2.75h-2.72v-24.37h2.85v9.25h.17c.96-2.06,2.82-3.28,5.21-3.28,4.11,0,7.03,3.78,7.03,9.48s-2.85,9.42-7.16,9.42ZM44.22,105.16c-2.72,0-4.68,2.39-4.68,5.64v2.65c0,3.32,1.86,5.57,4.61,5.57,2.98,0,4.94-2.75,4.94-6.93s-1.96-6.93-4.87-6.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.83,124.9h2.59c1.19,0,1.79-.46,2.16-1.63l.46-1.39-6.47-18.74h3.02l4.44,13.4c.17.53.4,1.39.4,1.63h.13c0-.23.23-1.09.36-1.63l4.21-13.4h2.89l-6.9,21.02c-.83,2.45-1.89,3.18-4.58,3.18h-2.72v-2.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M82.13,114.28l2.85-.8c.99,3.61,3.08,5.44,6.17,5.44s4.94-1.66,4.94-4.28c0-5.47-12.37-3.32-12.37-11.11,0-3.78,2.88-6.2,7.3-6.2,3.78,0,6.37,1.76,7.76,5.21l-2.72,1.16c-1.23-2.62-2.75-3.75-5.14-3.75s-4.08,1.26-4.08,3.22c0,5.51,12.4,3.35,12.4,11.11,0,4.41-3.25,7.26-8.16,7.26s-7.89-2.62-8.95-7.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103.42,112.1c0-5.64,3.08-9.45,7.63-9.45s7.36,3.58,7.36,8.82v.63h-12.14c.07,4.28,2.02,6.93,5.07,6.93,2.16,0,3.68-1.29,4.81-4.01l2.42,1.06c-1.43,3.65-3.85,5.47-7.2,5.47-4.81,0-7.96-3.78-7.96-9.45ZM106.4,109.94h8.99c-.27-3.05-1.96-4.91-4.34-4.91s-4.15,1.82-4.64,4.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M133.99,121.05v-12.07c0-2.25-1.33-3.71-3.45-3.71-2.65,0-4.51,2.26-4.51,5.67v10.11h-2.85v-17.91h2.72v3.15h.13c.93-2.39,2.79-3.65,5.27-3.65,3.32,0,5.54,2.26,5.54,5.57v12.83h-2.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140.96,116.14l2.49-.96c.93,2.65,2.62,4.05,5.01,4.05,2.26,0,3.85-1.26,3.85-3.08,0-4.54-9.98-2.09-9.98-8.32,0-3.15,2.49-5.17,6.13-5.17,2.98,0,5.17,1.36,6.5,4.05l-2.35,1.19c-.96-1.92-2.42-2.92-4.28-2.92s-3.15,1-3.15,2.52c0,4.18,10.01,1.79,10.01,8.32,0,3.42-2.75,5.74-6.76,5.74-3.61,0-6.17-1.86-7.46-5.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M161.09,96.51c1.06,0,1.89.76,1.89,1.82s-.83,1.82-1.89,1.82-1.86-.73-1.86-1.82.8-1.82,1.86-1.82ZM159.66,121.05v-17.91h2.85v17.91h-2.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M168.42,121.05v-17.91h2.72v3.68h.13c.8-2.39,2.82-3.68,5.01-3.68h1.79v2.79h-1.92c-3.02,0-4.87,1.96-4.87,5.24v9.88h-2.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M183.37,96.51c1.06,0,1.89.76,1.89,1.82s-.83,1.82-1.89,1.82-1.86-.73-1.86-1.82.8-1.82,1.86-1.82ZM181.95,121.05v-17.91h2.85v17.91h-2.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M197.57,121.55c-4.71,0-7.89-3.78-7.89-9.45s3.18-9.45,7.89-9.45,7.89,3.78,7.89,9.45-3.18,9.45-7.89,9.45ZM197.57,105.23c-3.05,0-4.97,2.72-4.97,6.86s1.92,6.86,4.97,6.86,4.97-2.72,4.97-6.86-1.92-6.86-4.97-6.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M221.15,121.05v-12.07c0-2.25-1.33-3.71-3.45-3.71-2.65,0-4.51,2.26-4.51,5.67v10.11h-2.85v-17.91h2.72v3.15h.13c.93-2.39,2.79-3.65,5.27-3.65,3.32,0,5.54,2.26,5.54,5.57v12.83h-2.85Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogoKuvaBySensirionInvert);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Logo_Kuva-by-Sensirion_Invert.d4ffbbd70209fa8cd9c3ded44a51cc92.svg";